import defaultProps from '../../../../config/defaultProps'
import User from '../../models/User'
import RequestProps from '../../props/RequestProps'
import { EmployeeVacation } from '../../utils/VacationTypes'

export interface SelectedDataState {
  users: User[]
  selectedEmployee: EmployeeVacation | null
  selectedDateCell: string | null
  comment: string
  endDateValue: string | null
  secondAnchorEl: HTMLElement | null
  secondSelectedEmployee: EmployeeVacation | null
  secondSelectedDateCell: string | null
  secondComment: string
  secondEndDateValue: string | null
  secondOpen: boolean
  choiceAnchorEl: HTMLElement | null
  isViewDialogOpen: boolean
  newEnd: string | null
  desc: string | null
  isDialogOpen: boolean
  isSecondDialogOpen: boolean
  requestProps: RequestProps
  startDate: string | null
  usersCount: number
  hoveredDate: string | null
  vacationId: string | null
  vacationIds: string[]
  displayStart: string | null
  displayEnd: string | null
  createdAt: string | null
}

export const defaultSelectedVacationData: SelectedDataState = {
  selectedEmployee: null,
  selectedDateCell: null,
  comment: '',
  endDateValue: null,
  secondAnchorEl: null,
  secondSelectedEmployee: null,
  secondSelectedDateCell: null,
  secondComment: '',
  secondEndDateValue: null,
  secondOpen: false,
  choiceAnchorEl: null,
  isViewDialogOpen: false,
  newEnd: null,
  desc: null,
  isDialogOpen: false,
  isSecondDialogOpen: false,
  requestProps: defaultProps,
  startDate: null,
  users: [],
  usersCount: 0,
  hoveredDate: null,
  vacationId: null,
  vacationIds: [],
  displayStart: null,
  displayEnd: null,
  createdAt: null,
}
